var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.reasonTags),function(tag){return _c('v-tooltip',{key:tag,staticClass:"mr-1",attrs:{"top":""}},[_c('v-chip',{attrs:{"slot":"activator","outline":"","color":"red lighten-1"},slot:"activator"},[_c('img',{attrs:{"src":_vm.getTagIconUrl(tag),"alt":_vm.getTagIconText(tag),"width":"24px"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getTagName(tag)))])],1)}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5034e9d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/TagReasonsList.vue
// module id = 290
// module chunks = 1